import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HalfWidthCol from "./HalfWidthCol";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";

function BrandsPageIntro({ heading, text }) {
  return (
    <BoxWithGutter pt={[38, null, 100, null]}>
      <Box maxWidth={[null, "80vw", null, null]} mx="auto">
        <IndentedParagraphMedium>{heading}</IndentedParagraphMedium>
      </Box>
      <HalfWidthCol pt={[38, null, 100, null]}>
        <RichTextLarge>{text}</RichTextLarge>
      </HalfWidthCol>
    </BoxWithGutter>
  );
}

export default BrandsPageIntro;

BrandsPageIntro.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
